const FALLBACK = [
  'UTC', 'America/St_Johns', 'America/Halifax', 'America/Toronto', 'America/New_York', 'America/Chicago',
  'America/Winnipeg', 'America/Edmonton', 'America/Denver', 'America/Vancouver', 'America/Los_Angeles',
  'America/Mexico_City', 'America/Sao_Paulo', 'Europe/London', 'Europe/Dublin', 'Europe/Paris', 'Europe/Berlin',
  'Europe/Zagreb', 'Europe/Madrid', 'Europe/Rome', 'Europe/Athens', 'Africa/Johannesburg', 'Asia/Dubai',
  'Asia/Kolkata', 'Asia/Singapore', 'Asia/Shanghai', 'Asia/Tokyo', 'Australia/Sydney', 'Pacific/Auckland',
];

let cached: string[] | null = null;

/** Every IANA zone the browser knows (UTC first). */
export function timezones(): string[] {
  if (cached) return cached;
  let list: string[] = [];
  try {
    list = Intl.supportedValuesOf('timeZone');
  } catch {
    list = FALLBACK;
  }
  if (!list.length) list = FALLBACK;
  cached = ['UTC', ...list.filter((z) => z !== 'UTC')];
  return cached;
}

export function browserTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}

/** `America/Toronto` → `Toronto (America) · GMT-4`. */
export function timezoneLabel(zone: string): string {
  const parts = zone.split('/');
  const city = (parts[parts.length - 1] ?? zone).replace(/_/g, ' ');
  const region = parts.length > 1 ? parts.slice(0, -1).join(' / ').replace(/_/g, ' ') : '';
  let offset = '';
  try {
    offset =
      new Intl.DateTimeFormat('en-US', { timeZone: zone, timeZoneName: 'shortOffset' })
        .formatToParts(new Date())
        .find((p) => p.type === 'timeZoneName')?.value ?? '';
  } catch {
    offset = '';
  }
  return [region ? `${city} (${region})` : city, offset].filter(Boolean).join(' · ');
}

export const CURRENCIES = ['CAD', 'USD', 'EUR', 'GBP', 'AUD', 'NZD', 'MXN', 'CHF', 'SEK', 'NOK', 'DKK', 'JPY', 'CNY', 'INR'] as const;
